import { render, staticRenderFns } from "./MotoboyDeliver.vue?vue&type=template&id=36b95404"
import script from "./MotoboyDeliver.vue?vue&type=script&lang=js"
export * from "./MotoboyDeliver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports